import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastHandler = () => {
  return (
    <>
      <ToastContainer
        autoClose={4000}
        pauseOnFocusLoss={false}
        closeOnClick={true}
        pauseOnHover={false}
        closeButton={true}
        position="top-right"
        style={{ position: "fixed", top: "79px", right: "1rem", zIndex: 9999, width: "410px" }}
      />
    </>
  );
};

export default ToastHandler;
